import React from "react";
import { Col, Container, Row } from "reactstrap";
import "../styles/about.css";
import ResumePDF from "../Assests/resume.pdf";

const About = () => {
  const handleButtonClick = () => {
    const resumePath = ResumePDF;
    window.open(resumePath, "_blank");
  };
  return (
    <Container fluid className="about">
      <Row className="text-center about1">
        <div className="d-flex align-items-center justify-content-center flex-column">
          <h1>About Me</h1>
          <span className="line" />
        </div>

        <Col lg="6" md="6" sm="6" xs="6">
          <div className="about-img">
            <span className="img-back"></span>
            <img
              src="https://www.vippng.com/png/full/78-787473_anime-boy-blackhair-raven-anime-boy-black-and.png"
              alt=""
            />
          </div>
        </Col>
        <Col lg="6" md="6" sm="6" xs="12">
          <div className="about-right">
            <span className="about-span1">Who I am ?</span>
            <br />
            <p className="about-span2">
              " Success is not final, failure is not fatal: <br />
              <span> It is the courage to continue that counts".</span>
            </p>{" "}
            <br />
            <p className="about-para">
              I am PraveenGanth, stand fearlessly at the intersection of
              creativity and innovation, armed with the skills of a full-stack
              developer in the dynamic world of MERN. Let's build something
              extraordinary together!
            </p>
            <br />
            <button className="hire-me" onClick={handleButtonClick}>
              My Resume
            </button>
          </div>
        </Col>

        <Col className="about3">
          <p className=" fw-bold fs-2">professional Journey</p>
          <div className=" professional-blcok">
            <div className="card about-card" style={{ width: "18rem" }}>
              <img
                src="https://img.freepik.com/free-vector/vector-student-hat-isolated-white_1284-41884.jpg?w=740&t=st=1703774757~exp=1703775357~hmac=7edce0e4e5a5b74da0b471d617aa21ff07be310990c36164e62297f6a734f7a8"
                className="card-img-top"
                alt="..."
              />
              <div
                className="card-body about-card-body"
                style={{ textAlign: "start" }}
              >
                <h3>2017 to 2020</h3>
                <p className="card-text">
                  Formerly armed with a BSc in Chemistry, I've transitioned into
                  the world of web development, where I weave digital
                  experiences with precision and creativity.
                </p>
              </div>
            </div>
            <div className="card about-card" style={{ width: "18rem" }}>
              <img
                src="https://img.freepik.com/free-vector/graduation-mortar-top-books_433751-268.jpg?w=740&t=st=1703775344~exp=1703775944~hmac=d299387ff833917041457628aed70b66776e5295a32690f24bf139e9ca03fd1d"
                className="card-img-top"
                alt="..."
              />
              <div
                className="card-body about-card-body"
                style={{ textAlign: "start" }}
              >
                <h3>2021 to 2022</h3>
                <p className="card-text">
                  In 2021-2022, I mastered MERN stack, excelling in front-end.
                  Now diving into backend for full-stack prowess.
                </p>
              </div>
            </div>
            <div className="card about-card" style={{ width: "18rem" }}>
              <img
                src="https://img.freepik.com/free-photo/character-with-tie-briefcase_1156-551.jpg?w=740&t=st=1703775537~exp=1703776137~hmac=f662fed9e7286d76c2c276c624acc4078a619e72c908a7ab2dcc699b84b84df9"
                className="card-img-top"
                alt="..."
              />
              <div
                className="card-body about-card-body"
                style={{ textAlign: "start" }}
              >
                <h3>2023 </h3>
                <p className="card-text">
                  Since August 14, I've been actively contributing as an intern
                  front-end developer at Automios, adding practical experience
                  to my skill set.
                </p>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default About;
